export default __webpack_public_path__ + "static/media/cancel-listings-fractal.6e89a77a.png";